"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceEventsAccessor = exports.DataSourceInstanceAccessor = exports.DataSourceInstancesAccessor = exports.DataSourceAccessor = exports.DataSourcesAccessor = void 0;
const iframe_1 = require("../iframe");
const accessors_1 = require("../accessors");
class DataSourcesAccessor extends accessors_1.ElementListAccessor {
    constructor(client) {
        super(client, 'data-sources');
    }
}
exports.DataSourcesAccessor = DataSourcesAccessor;
class DataSourceAccessor extends accessors_1.ElementAccessor {
    constructor(client, idOrKey) {
        super({
            client,
            path: 'data-sources',
            idOrKey,
        });
    }
}
exports.DataSourceAccessor = DataSourceAccessor;
class DataSourceInstancesAccessor extends accessors_1.ElementInstanceListAccessor {
    constructor(client) {
        super(client, 'data-source-instances');
    }
}
exports.DataSourceInstancesAccessor = DataSourceInstancesAccessor;
class DataSourceInstanceAccessor extends accessors_1.ElementInstanceAccessor {
    constructor(client, selector) {
        super({
            client,
            instancePath: 'data-source-instance',
            selector,
        });
        this.client = client;
    }
    async setup() {
        await this.client.post(this.getPath('setup'));
    }
    async subscribe(eventType) {
        await this.client.post(this.getPath(`events/${eventType}/subscribe`));
    }
    async resubscribe(eventType) {
        await this.client.post(this.getPath(`events/${eventType}/resubscribe`));
    }
    async unsubscribe(eventType) {
        await this.client.post(this.getPath(`events/${eventType}/unsubscribe`));
    }
    async pullUpdates() {
        const id = await this.getId();
        await this.client.post(`/data-source-instances/${id}/pull-updates`);
    }
    async fullSync() {
        const id = await this.getId();
        await this.client.post(`/data-source-instances/${id}/full-sync`);
    }
    async reset() {
        await this.client.post(this.getPath('reset'));
    }
    async unifiedFieldsToNative(unifiedFields) {
        return this.client.post(this.getPath('unified-fields-to-native'), unifiedFields);
    }
    async openConfiguration({ showPoweredBy, onClose } = {
        showPoweredBy: true,
    }) {
        const id = await this.getId();
        const uri = this.client.getEmbedUri(`/data-source-instances/${id}/configuration`, { showPoweredBy: showPoweredBy !== null && showPoweredBy !== void 0 ? showPoweredBy : true });
        return (0, iframe_1.openIframe)(uri, {
            onClose,
        });
    }
    async getCollection() {
        return this.client.get(this.getPath('collection'));
    }
    async getLocations(request) {
        return this.client.get(this.getPath('locations'), request);
    }
    async findRecords(request = {}) {
        return this.client.post(this.getPath('collection/find'), request);
    }
    async findRecordById(id) {
        return this.client.post(this.getPath('collection/find-by-id'), {
            id,
        });
    }
    async createRecord(request) {
        return this.client.post(this.getPath('collection/create'), request);
    }
    async updateRecord(request) {
        return this.client.post(this.getPath(`collection/update`), request);
    }
    async deleteRecord(id) {
        return this.client.post(this.getPath(`collection/delete`), {
            id,
        });
    }
}
exports.DataSourceInstanceAccessor = DataSourceInstanceAccessor;
class DataSourceEventsAccessor extends accessors_1.ElementInstanceListAccessor {
    constructor(client) {
        super(client, 'data-source-events');
    }
}
exports.DataSourceEventsAccessor = DataSourceEventsAccessor;
//# sourceMappingURL=accessors.js.map